import React from "react";
import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";
import type { Root } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { store } from "../../../app/store";
import SingleProductContainer from "../components/productSingle/SingleProductContainer";

// Store created roots by their container ID
const roots: Record<string, Root> = {};

export function hydrateSingleProductContainer(rootId: string): void {
  const rootElement = document.getElementById(rootId);
  if (!rootElement) {
    console.error(`Failed to find root element with ID: ${rootId}`);
    return;
  }
  if (rootElement.dataset.reactInitialized === "true") {
    return;
  }
  try {
    if (roots[rootId]) {
      roots[rootId].render(
        <React.StrictMode>
          <Provider store={store}>
            <BrowserRouter>
              <Routes>
                <Route
                  path="/urun/:slug"
                  element={<SingleProductContainer />}
                />
              </Routes>
            </BrowserRouter>
          </Provider>
        </React.StrictMode>
      );
    } else {
      const root = createRoot(rootElement);
      roots[rootId] = root;
      root.render(
        <React.StrictMode>
          <Provider store={store}>
            <BrowserRouter>
              <Routes>
                <Route
                  path="/urun/:slug"
                  element={<SingleProductContainer />}
                />
              </Routes>
            </BrowserRouter>
          </Provider>
        </React.StrictMode>
      );
    }
    rootElement.dataset.reactInitialized = "true";
  } catch (error) {
    console.error("Error initializing SingleProductContainer:", error);
  }
}

declare global {
  interface Window {
    hydrateSingleProductContainer?: (rootId: string) => void;
  }
}

if (typeof window !== "undefined") {
  window.hydrateSingleProductContainer = hydrateSingleProductContainer;
}
